module.exports = __webpack_public_path__ + "img/code.b08a0f6a.png";